import { Router } from "@angular/router";
import { API_CALL_ERROR } from "./../../../store/action";
import { AppInjector } from "./../../../app-injector";
import { CREATE_CUSTOMER_REQUESTED, CREATE_CUSTOMER_SUCCEEDED } from "./create.actions";
import { ApiService } from "../../../api/api.service";
import { takeEvery, put } from "redux-saga/effects";
import * as _ from "lodash";
import { PreloaderService } from "../../../common/services/preloader/preloader.service";
import {NotificationService} from "../../../common/services/notification/notification.service";
import {UtilityService} from "../../../common/services/utility/utility.service";
import {USER_COMP} from "../../user/user.const";
import {CREATE_USER_SUCCEEDED} from "../../auth/create/create.actions";
import {CUSTOMER_COMP} from "../customer.const";
import {COLLECTION_CREATE_COMP} from "../../collection/collection.const";
import {CREATE_NEW_USER_COLLECTION_SUCCEEDED} from "../../collection/create/create.actions";

function* createCustomer(action) {
  AppInjector.get(PreloaderService).show();
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.user.create(action.data).toPromise();
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('success', 'Customer creation completed', 5000);
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case COLLECTION_CREATE_COMP:
          AppInjector.get(Router).navigate([action.redirect]);
          yield put({ type: CREATE_NEW_USER_COLLECTION_SUCCEEDED, id: result.getId() });
          break;
        case CUSTOMER_COMP:
          AppInjector.get(Router).navigate([`/customer/edit/${result.getId()}/account-info`]);
          break;
        default:
          break;
      }
    } else {
    }
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateCustomerRequest() {
  yield takeEvery(CREATE_CUSTOMER_REQUESTED, createCustomer);
}

// function* createCustomerSucceed(action) {
//   AppInjector.get(PreloaderService).show();
//   const api = AppInjector.get(ApiService);
//   try {
//     let result = yield api.user.create(action.data).toPromise();
//     AppInjector.get(PreloaderService).hide();
//     AppInjector.get(NotificationService).show('success', 'Customer creation completed', 5000);
//     AppInjector.get(Router).navigate([`/customer/edit/${result.getId()}/account-info`]);
//   } catch (e) {
//     AppInjector.get(PreloaderService).hide();
//     yield put({ type: API_CALL_ERROR, error: e });
//   }
// }
//
// function* watchCreateCustomerSucceeded() {
//   yield takeEvery(CREATE_CUSTOMER_SUCCEEDED, createCustomerSucceed);
// }

export default [watchCreateCustomerRequest];
